import { render, staticRenderFns } from "./PlaceDataTable.vue?vue&type=template&id=f60fb808&"
import script from "./PlaceDataTable.vue?vue&type=script&lang=js&"
export * from "./PlaceDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports